/** Trace — freehand drawing over a reference image (drop an image or load from the menu). */
import type { CreateModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import type { Point } from '../../core/scene';
import { defaultStyle } from '../../core/scene';
import { buildSmoothPath, distance } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 16l5-5 4 4 3-3 6 6" opacity="0.6"/><path d="M16 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" opacity="0.6"/></svg>';

export function createTrace(): CreateModule {
  let pts: Point[] = [];
  let drawing = false;

  return {
    manifest: {
      id: 'trace',
      kind: 'create',
      name: 'Trace',
      apiVersion: 1,
      description: 'Trace over a reference image — drop an image, or load one from the menu.',
      icon: ICON,
      capabilities: ['image'],
      params: [{ kind: 'slider', key: 'lineWidth', label: 'Weight', min: 0.5, max: 24, step: 0.5, default: 2 }],
    },

    onPointerDown(s) {
      pts = [{ x: s.x, y: s.y }];
      drawing = true;
    },

    onPointerMove(s) {
      if (!drawing) return;
      const p = { x: s.x, y: s.y };
      const last = pts[pts.length - 1];
      if (!last || distance(last, p) >= 1.2) pts.push(p);
    },

    onPointerUp() {
      drawing = false;
    },

    getLiveShapes(ctx) {
      if (pts.length === 0) return [];
      const style = defaultStyle();
      style.color = { ...ctx.ink };
      style.lineWidth = cfgNum(ctx.config, 'lineWidth', 2);
      return [ctx.newShape({ path: buildSmoothPath(pts), style })];
    },

    onClear() {
      pts = [];
    },

    onCommit() {
      pts = [];
    },
  };
}
